import { Color } from '../../../enums/color'
import { TagColor } from '../types'

// ─── PRIMARY type ────────────────────────────────────────────────────────────

// Default state
export const primaryDefaultBg: Record<TagColor, string> = {
  neutral: Color.Grey600,
  blue: Color.Lavender500,
  purple: Color.Purple600,
  pink: Color.Pink600,
  magenta: Color.Magenta600,
  red: Color.Red700,
  orange: Color.Orange600,
  yellow: Color.Yellow400,
  lime: Color.Lime400,
  green: Color.Green700,
  cyan: Color.Cyan400,
}

export const primaryDefaultBorder: Record<TagColor, string> = {
  neutral: Color.Grey700,
  blue: Color.Lavender600,
  purple: Color.Purple700,
  pink: Color.Pink700,
  magenta: Color.Magenta700,
  red: Color.Red800,
  orange: Color.Orange700,
  yellow: Color.Yellow600,
  lime: Color.Lime700,
  green: Color.Green950,
  cyan: Color.Cyan700,
}

export const primaryDefaultText = Color.White

// Hover state
export const primaryHoverBg: Record<TagColor, string> = {
  neutral: Color.Grey700,
  blue: Color.Lavender600,
  purple: Color.Purple700,
  pink: Color.Pink700,
  magenta: Color.Magenta700,
  red: Color.Red800,
  orange: Color.Orange700,
  yellow: Color.Yellow500,
  lime: Color.Lime500,
  green: Color.Green800,
  cyan: Color.Cyan500,
}

export const primaryHoverBorder: Record<TagColor, string> = {
  neutral: Color.Grey900,
  blue: Color.Lavender700,
  purple: Color.Purple800,
  pink: Color.Pink800,
  magenta: Color.Magenta800,
  red: Color.Red800,
  orange: Color.Orange800,
  yellow: Color.Yellow700,
  lime: Color.Lime800,
  green: Color.Green950,
  cyan: Color.Cyan800,
}

// Selected state — uniform border for all colors
export const primarySelectedBorder = Color.Grey900

// ─── SUBTLE type ─────────────────────────────────────────────────────────────

// Default state
export const subtleDefaultBg: Record<TagColor, string> = {
  neutral: Color.Grey50,
  blue: Color.Lavender100,
  purple: Color.Purple50,
  pink: Color.Pink100,
  magenta: Color.Magenta100,
  red: Color.Red100,
  orange: Color.Orange100,
  yellow: Color.Yellow100,
  lime: Color.Lime100,
  green: Color.Green100,
  cyan: Color.Cyan100,
}

export const subtleDefaultBorder: Record<TagColor, string> = {
  neutral: Color.Grey100,
  blue: Color.Lavender200,
  purple: Color.Purple200,
  pink: Color.Pink200,
  magenta: Color.Magenta200,
  red: Color.Red200,
  orange: Color.Orange200,
  yellow: Color.Yellow400,
  lime: Color.Lime200,
  green: Color.Green300,
  cyan: Color.Cyan200,
}

export const subtleDefaultText: Record<TagColor, string> = {
  neutral: Color.Grey800,
  blue: Color.Lavender600,
  purple: Color.Purple700,
  pink: Color.Pink700,
  magenta: Color.Magenta700,
  red: Color.Red700,
  orange: Color.Orange700,
  yellow: Color.Yellow700,
  lime: Color.Lime700,
  green: Color.Green700,
  cyan: Color.Cyan700,
}

// Hover state
export const subtleHoverBg: Record<TagColor, string> = {
  neutral: Color.Grey100,
  blue: Color.Lavender200,
  purple: Color.Purple200,
  pink: Color.Pink200,
  magenta: Color.Magenta200,
  red: Color.Red200,
  orange: Color.Orange200,
  yellow: Color.Yellow200,
  lime: Color.Lime200,
  green: Color.Green200,
  cyan: Color.Cyan200,
}

export const subtleHoverBorder: Record<TagColor, string> = {
  neutral: Color.Grey200,
  blue: Color.Lavender200,
  purple: Color.Purple200,
  pink: Color.Pink200,
  magenta: Color.Magenta200,
  red: Color.Red200,
  orange: Color.Orange200,
  yellow: Color.Yellow400,
  lime: Color.Lime200,
  green: Color.Green300,
  cyan: Color.Cyan200,
}

// Selected state
export const subtleSelectedBorder: Record<TagColor, string> = {
  neutral: Color.Grey900,
  blue: Color.Lavender600,
  purple: Color.Purple600,
  pink: Color.Pink600,
  magenta: Color.Magenta600,
  red: Color.Red600,
  orange: Color.Orange600,
  yellow: Color.Yellow600,
  lime: Color.Lime600,
  green: Color.Green600,
  cyan: Color.Cyan600,
}

// ─── Disabled state (shared — identical for both primary and subtle) ──────────

export const disabledBg: Record<TagColor, string> = {
  neutral: Color.Grey100,
  blue: Color.Lavender100,
  purple: Color.Purple50,
  pink: Color.Pink50,
  magenta: Color.Magenta50,
  red: Color.Red100,
  orange: Color.Orange50,
  yellow: Color.Yellow100,
  lime: Color.Lime50,
  green: Color.Green100,
  cyan: Color.Cyan50,
}

export const disabledText: Record<TagColor, string> = {
  neutral: Color.Grey400,
  blue: Color.Lavender400,
  purple: Color.Purple400,
  pink: Color.Pink400,
  magenta: Color.Magenta400,
  red: Color.Red400,
  orange: Color.Orange400,
  yellow: Color.Yellow600,
  lime: Color.Lime400,
  green: Color.Green600,
  cyan: Color.Cyan400,
}
